module.exports = __webpack_public_path__ + "media/assets/images/flags/fk-8f246cb59a6d75ced52905389345616b.svg";